var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.45661 5.54688L0.699707 5.54688L0.699707 16.5469L4.45661 16.5469L4.45661 5.54688Z",
    fill: "#2E392F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6899 5.67588C14.65 5.66388 14.6122 5.65088 14.5702 5.63988C14.5198 5.62888 14.4694 5.61988 14.418 5.61188C14.2185 5.57388 14.0001 5.54688 13.7439 5.54688C11.5536 5.54688 10.1644 7.06388 9.70661 7.64988L9.70661 5.54688L5.94971 5.54688L5.94971 16.5469L9.70661 16.5469L9.70661 10.5469C9.70661 10.5469 12.5458 6.78088 13.7439 9.54688C13.7439 12.0159 13.7439 16.5469 13.7439 16.5469L17.4997 16.5469L17.4997 9.12387C17.4997 7.46187 16.3038 6.07688 14.6899 5.67588Z",
    fill: "#2E392F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53721 4.04688C3.55203 4.04688 4.37471 3.26337 4.37471 2.29688C4.37471 1.33038 3.55203 0.546875 2.53721 0.546875C1.52238 0.546875 0.699707 1.33038 0.699707 2.29688C0.699707 3.26337 1.52238 4.04688 2.53721 4.04688Z",
    fill: "#2E392F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 16,
    fill: "white",
    transform: "translate(0.699707 0.546875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cc61be03f819348eaf2f3288b4d4c432.svg";
export { ForwardRef as ReactComponent };